import * as angular from "angular";
import {IController} from "angular";

export class fulfillmentAttemptsListCtrl implements IController {

  attempts: any;
  step: any;

  /* @ngInject */
  constructor() {}

  $onInit() {

  }

}
angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentAttemptsList', {
    bindings: {
      attempts: '<',
      step: '<'
    },
    template: require('./fulfillment-attempts-list.html').default,
    controller: fulfillmentAttemptsListCtrl
  });
